import { preloadSpaceGuestList } from '@confluence/space-guest-list/entry-points/preloadSpaceGuestList.ts';
import { preloadShortcutsSmartLinks } from '@confluence/space-shortcuts/entry-points/preloadShortcutsSmartLinks.ts';
import { preloadSideNavigation } from '@confluence/side-navigation/entry-points/preloadSideNavigation.ts';
import { preloadSpaceViews } from '@confluence/space-views/entry-points/preloadSpaceViews.ts';
import { preloadPageTree } from '@confluence/page-tree/entry-points/preloadPageTree.ts';
import { preloadBlogTree } from '@confluence/blog-tree/entry-points/preloadBlogTree.ts';
import { PAGE_TREE_STATUSES } from '@confluence/page-tree/entry-points/pageTreeStatuses.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadIsUserViewingSpaceAsAnon } from '@confluence/anonymous-access/entry-points/preloadIsUserViewingSpaceAsAnon.ts';

export const preloadNavigationTasks = async (
	spaceKey: string,
	contentId: string,
	isLicensed: boolean,
	isBlog: boolean,
	previousSpaceKey?: string,
): Promise<void | any[] | Error[]> => {
	return waitForAllReturnWhenError([
		preloadSpaceGuestList(spaceKey),
		preloadShortcutsSmartLinks(spaceKey),
		preloadSideNavigation(spaceKey, previousSpaceKey),
		preloadSpaceViews(spaceKey, isLicensed),
		preloadIsUserViewingSpaceAsAnon(spaceKey),
		preloadPageTree({
			spaceKey,
			...(isBlog ? {} : { contentId }),
			statuses: PAGE_TREE_STATUSES,
			isSuperAdmin: false,
		}),
		preloadBlogTree({ spaceKey }),
	]);
};
